import React from "react";

import { AboutHeader } from "../components";

import "../css/about.css";
const About = () => {
  return (
    <div className="about">
      <AboutHeader />

      <main>
        <h2>المراحل الدراسية</h2>
        <ul>
          <li>ليسانس كلية الآداب قسم اللغة الانجليزية 1987 .</li>
          <li> ليسانس كلية الآداب قسم آثار مصرية قديمة جامعة المنصورة 2006 .</li>
        </ul>
        <br/>
        
        <h2>العضوية</h2>
        <ul>
          <li>عضو آتيليه القاهرة ( جماعة الفنانين والكتاب ) .</li>
          <li>الجمعية الاهلية للفنون الجميلة</li>
          <li>عضو الجمعية المصرية للتصوير الفوتوغرافى</li>
          <li>عضو الاتحاد الدولى للتصوير الفوتوغرافى</li>
          <li>عضو آتيليه المنصورة</li>
        </ul>
        <br/>
        
        <h2>الوظائف و المهن التى اضطلع بها الفنان</h2>
        <ul>
          <li>مصور فوتوغرافى محترف وحر .</li>
          <li>صاحب استوديو تصوير .</li>
          <li>مؤلف كتب خاصة بالتصوير الضوئى وآثار وتاريخ مصر القديمة .</li>
          <li>مؤلف مجموعة كتب خاصه ببعض الفنانين التشكيليين المصريين والعرب والأجانب.</li>
        </ul>
        <br/>
        
        <h2>الأماكن التى عاش بها الفنان</h2>
        <ul>
          <li>المنصورة.</li>
          <li>الإسكندرية .</li>
          <li>القاهرة .</li>
          <li>لمملكه المتحده ( إنجلترا ) .</li>
          <li>باريس (فرنسا) .</li>
        </ul>
        <br/>

        <h2>اللمعارض الخاصة</h2>
        <ul>
          <li>
             معرض ( مصر أمس واليوم وغدا ) بورتثماوث انجلترا 1982.
          </li>
          
          <li>
            معرض ( ذكريات مالك الحزين ) المنصورة 1990.
          </li>
          
          <li>
            معرض ( هميس الارض والماء والشجر ) المنصورة طنطا الزقازيق 1993 .
          </li>
          
          <li>
            معرض ( رؤيا فوتوغرافية ) عن حرب لبنان 1994 .
          </li>
          
          <li>
            معرض ( نظرة أخيرة ) 1995 .
          </li>
          
          <li>
            معرض ( كانت وستظل حياتى ) بأتيليه القاهرة 1996 .
          </li>
          
          <li>
            معرض ( مصر هتفضل جوه عينى ) بأتيليه القاهرة ديسمبر 2000 .
          </li>
          
          <li>
            معرض ( مصر من تانى ) بمتحف المنصورة القومى 2001 .
          </li>
          
          <li>
            معرض ( بيت ملايين السنين ) بأتيليه القاهرة وبدار ابن لقمان بمتحف المنصورة القومى 2006 .
          </li>
          
          <li>
            معرض ( من بين 8888 صورة وصورة ) بمركز محمود سعيد أتيليه القاهرة متحف إبن لقمان قصور ثقافة بور سعيد والأقصر وأسوان والغردقة وشرم الشيخ 2008 .
          </li>
          
          <li>
            معرض بعنوان ( مش عابر سبيل ) ( من وحى أغنيات الفنان على الحجار ) بقاعة ( الأرض ) بساقية عبد المنعم الصاوى أغسطس 2008 .
          </li>
          
          <li>
            معرض بعنوان ( الإسكندرية عاصمة الثقافة الإسلامية ) بمركز محمود سعيد للمتاحف بالإسكندرية أغسطس 2009 .
          </li>
          
          <li>
            معرض بمركز الإبداع بالإسكندرية أكتوبر 2010 .
          </li>
          
          <li>
            معرض بعنوان (عندما ترسم الكاميرا من تانى) بمدينة شرم الشيخ نوفمبر 2011 .
          </li>
        </ul>
        <br/>
        
        <h2>المعارض الجماعية المحلية</h2>
        <ul>
          <li>
            جميع معارض ظلال والوان.
          </li>
          
          <li>
            جميع معارض ريشة وعدسة .
          </li>
          
          <li>
            معرض ( ذكريات موناليزا ) بالاشتراك مع المصور الفنان الراحل محمد يوسف كبير مصورى الأهرام ـ رأس البر 1987.
          </li>
          
          <li>
            معارض الجمعية المصرية للتصوير الفوتوغرافى 1983حتى 1990.
          </li>
          
          <li>
            صالون النيل الاول للتصوير الضوئى 1990.
          </li>
          
          <li>
            المعرض العام للفنون التشكيلية الدورة ( 22 ) 1991.
          </li>
          
          <li>
            صالون الشباب الثانى 1990، الرابع 1992.
          </li>
          
          <li>
            صالون النيل الثانى للتصوير الضوئى 1995 .
          </li>
          
          <li>
            صالون مصر للتصوير الضوئى اكتوبر 1997 .
          </li>
          
          <li>
            المعرض القومى للفنون التشكيلية ( 25 ) 1997 ، الدورة ( 27 ) 2001 .
          </li>
          
          <li>
            صالون النيل الثالث للتصوير الضوئى 2001 ، الرابع 2002 .
          </li>
          
          <li>
            المعرض القومى للفنون التشكيلية الدورة ( 29 ) 2005 .
          </li>
          
          <li>
            مهرجان الإبداع التشكيلى الأول ( المعرض العام الدورة الثلاثون وسوق الفن التشكيلى الأول ) 2007 .
          </li>
          
          <li>
            مهرجان الإبداع التشكيلى الثانى ( المعرض العام الدورة الواحد و الثلاثون) 2008 .
          </li>
          
          <li>
            معرض إنفعالات وطنية بمقر الأمانة العامة لجامعة الدول العربية ميدان التحرير 2008 .
          </li>
          
          <li>
            الصالون الثانى لأتيليه المنصورة بمكتبة مبارك العامة بالمنصورة نوفمبر 2008 .
          </li>
          
          <li>
            صالون النيل السابع للتصوير الضوئى 2009 .
          </li>
          
          <li>
            المهرجان الثالث لأتيلييه المنصورة بقاعة العرض بمكتبة مبارك بالمنصورة ديسمبر 2009 .
          </li>
          
          <li>
            معرض ( انفعالات وطنية ) بقاعتى ` بيكار عبد السلام الشريف ` بنقابة الصحفيين يناير 2010 .
          </li>
          
          <li>
            معرض ( صرخة غضب إلى العالم ارض العرب للعرب ) بقاعة الفنون التشكيلية بقصر ثقافة المنصورة أبريل 2010 .
          </li>
          
          <li>
            الصالون الرابع لفنانى آتيليه المنصورة للفنون والثقافة بمكتبة مبارك العامة بالمنصورة ديسمبر 2010 .
          </li>
          
          <li>
            صالون الدقهلية الخامس عشر لفنانى نقابة التشكيليين بالدقهلية يونيو 2011 .
          </li>
          
          <li>
            المعرض العام للفنون التشكيلية الدورة ( 36 ) يونيو 2014 .
          </li>
          
          <li>
          معرض المبدعون العرب الأول بجاليرى اوستراكا بوسط البلد مايو 2016 .  
          </li>
        </
        ul>
        <br/>
        
        <h2>المعارض الجماعية الدولية/المعارض الخارجية</h2>
        <ul>
          <li>
            معرض المنظمة العالمية لحقوق الإنسان 1989.
          </li>
          
          <li>
            معرض يوم الأرض ـ فلسطين 1990 .
          </li>
          
          <li>
            معرض التصوير الفوتوغرافى بعنوان ( الحضارة المصرية ) ضمن فعاليات الاسبوع الثقافى بالعاصمة البلغارية صوفيا أكتوبر 2006 .
          </li>
          
          <li>
            بينالى الثقافه والفنون الدولى الثانى ( ثوره وتلاحم ) بالقاهره مصر يونيو 2011 .
          </li>
          
          <li>
            معرض ( صالون الخريف الفرنسى ) بمتحف جراند بالية الشانزليزيه أكتوبر 2011 .
          </li>
          
          <li>
          صالون الجنوب الدولى الرابع بكلية الفنون الجميلة بالأقصر مارس 2016 .  
          </li>
        </
        ul>
        <br/>
        
        <h2>البعثات و المنح</h2>
        <ul>
          <li>
            سافر إنجلترا عام 1982 لتعلم فن التصوير الضوئى بأرقى المعاهد هناك وعاد بعد أن حصل على المركز الأول فى ترتيب التخرج بين أقرانه من كل أنحاء العالم وأقاموا له معرضا خاصا هناك وهو الأول فى حياته على الإطلاق وأسماه ( مصر أمس واليوم وغدا ) بمدينة بورتثموث بالمملكه المتحده.
          </li>
        </ul>
        <br/>

        <h2>المهام الفنية التى كلف بها و الاسهامات العامة</h2>
        <ul>
          <li>
            أختير لتمثيل مصر بمعرض المنظمة العالمية لحقوق الانسان عام 1989.
          </li>
          
          <li>
            اختير لتمثيل مصر بمعرض يوم الارض فلسطين عام 1990.
          </li>
          
          <li>
            أختير لعمل معرض عن مدينة الأسكندريه بمناسبة إختيارها عاصمة الثقافه الإسلاميه لعام 2008 بمركز محمود سعيد للمتاحف بالأسكندريه من 14-8 -2008 إلى 24-8-2008 .
          </li>
          
          <li>
            أختير لتمثيل مصر بصالون الخريف الفرنسى الدورة 120 كأول فنان فوتوغرافى بالعالم يرسم بالكاميرا وعرضت أعماله بباريس بالجراند باليه بشارع الشانزليزيه وإختاروا أعماله هناك لتعرض فى مدخل الصالون تكريما له عام 2011 .
          </li>
        </ul>
        <br/>
        
        <h2>الموسوعات المحلية و العالمية المدرج فيها اسم الفنان</h2>
        <ul>
          <li>
            موسوعة صالون الشباب الجزء الاول اعداد الدكتور/صبحى الشارونى 1994 اصدار قطاع الفنون التشكيلية.
          </li>
        </ul>
        <br/>
        
        <h2>المؤلفات و الأنشطة الثقافية</h2>
        <ul>
          <li>رؤيا فوتوغرافية .</li>
          <li>نظره أخيره .</li>
          <li>33 سؤال و جواب فى التصوير الفوتوغرافى .</li>
          <li>الفن المصرى القديم 3 أجزاء: 1المقابر . 2 المعابد . 3 الأهرامات .</li>
          <li>عاشق القرية عن لوحات الفنان التشكيلى بدوى سعفان .</li>
          <li>حوار مع بيكار آخر حوار مع الفنان الراحل حسين بيكار فى منزله بالزمالك ومسجل فيديو صوت وصورة .</li>
          <li>محسن شعلان (ذات يوم عاصف مطير).</li>
          <li>فاروق حسنى (ذكريات ملونه بالدموع).</li>
          <li>صالون الخريف الفرنسى (ماله وماعليه).</li>
          <li><del>عبد الرازق عكاشه (فنان وفلاح مصرى عشت معه فى باريس).</del></li>
          <li>أحمد بكر (لوحات ملونه بالذكريات).</li>
          <li>أحمد الجناينى (فى مواجهة بيكاسو وموديليانى).</li>
        </ul>
        <br/>
        
        <h2>الجوائز المحلية</h2>
        <ul>
          <li>المركز الأول فى المسابقة القومية للفنون التشكيلية 1987.</li>
          <li>المركز الثانى فى صالون الشباب الثانى 1990.</li>
          <li>الجائزة التشجيعية فى صالون الشباب الرابع 1992 .</li>
        </ul>
        <br/>
        
        <h2>الجوائز الدولية</h2>
        <ul>
          <li>
            جائزة البيئة من الأمم المتحدة 1994.
          </li>

          <li>
            جائزة اللقطة الأسرع بمسابقة آكشن عن لوحته المسماه ( آكشن ) بأمريكا من الإتحاد الدولى للتصوير الفوتوغرافى 2008.
          </li>
        </ul>
        <br/>
        
        <h2>مقتنيات خاصة</h2>
        <ul>
          <li>
            لدى بعض الأفراد بمصر - الولايات المتحدة - إنجلترا - فرنسا - إيطاليا - سويسرا - ألمانيا - النمسا .
          </li>
        </ul>
        <br/>
        
        <h2>مقتنيات رسمية</h2>
        <ul>
          <li>.متحف الفن المصرى الحديث</li>
        </ul>
        <br/>
      </main>
    </div>
  );
};

export default About;
